import React from 'react'
import { Link } from 'react-router-dom'

const UnautorizedPage = () => {
    return (
        <div className="container-fluid">
           You are not authorized to access the page. 
           Please <Link to={'/main-dashboard'}>Click here </Link> to go to Dashboard
        </div>
    )
}

export default UnautorizedPage
